module.exports = __webpack_public_path__ + "static/img/甲烷瓦斯探头检测.55d8b9a9.png";